import { useContext, useEffect, useState } from "react";
import { ContextStatus } from "@leedpulse-monorepo/enums";
import getContactsQueueStats, { ContactsQueueStats } from "../../../domain/use_cases/leedflow/overview/getContactsQueueStats";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

/** Cadence du rafraîchissement de la santé de la queue d'import de contacts. */
const REFRESH_MS = 30_000;

export const useContactsQueueStats = () => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;
    const [stats, setStats] = useState<ContactsQueueStats>({ pending: 0, failed: 0, oldestPendingCreated: null, estimatedMinutesRemaining: 0 });
    // LOADING dès l'état initial, et jamais reposé ensuite : un squelette qui
    // réapparaît toutes les 30 secondes fait clignoter le bloc pour rien.
    const [status, setStatus] = useState<ContextStatus>(ContextStatus.LOADING);

    useEffect(() => {
        if (!auth) return;

        let cancelled = false;

        const load = async () => {
            try {
                const res = await getContactsQueueStats(auth);
                if (cancelled) return;
                setStats(res);
                setStatus(ContextStatus.SUCCESS);
            } catch (error) {
                if (cancelled) return;
                console.error(error);
                setStatus(ContextStatus.ERROR);
            }
        };

        // Premier appel immédiat puis toutes les 30 s.
        load();
        const timer = setInterval(load, REFRESH_MS);

        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [auth]);

    return { stats, status };
};
